export default __webpack_public_path__ + "static/media/it-72.49061f13.svg";